import { UserSelectableItem } from "../../user/User.types";
import { ActivitySearchItem } from "./ActivitiesSearch.types";

export function withResponsible(activity: ActivitySearchItem, responsible: UserSelectableItem): ActivitySearchItem {
    return {
        ...activity,
        responsibleId: responsible.id,
        // The responsible column renders from the fields list, so the display name has to move with the id.
        fields: activity.fields.map((field) => (field.fieldId === "responsible" ? { ...field, value: [responsible.name] } : field)),
    };
}
